<template>
  <ul class="slm-theme-list__card-list" :class="{'odd': highlightPosts.length % 2 === 1}" :style="`--columns: ${columns}`">
    <li v-for="post in highlightPosts" :key="post.id" class="slm-theme-list__card-list-item">
      <Card :post="post" />
    </li>
  </ul>
</template>

<script>
import Card from './Card.vue';

export default {
  name: "card-list-component",
  computed: {
    highlightPosts() {
      return this.$store.state.highlightPosts;
    },
    columns() {
      return this.$store.state.columns;
    }
  },
  components: {
    Card
  }
};
</script>
